import React, { useEffect, useState } from "react";
import "./css/Companies.scss";
import LogoSlider from "./LogoSlider";
import axios from "axios";

function Companies() {
  const [avatars, setAvatars] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
     const filterDuplicateLogos = (logos) => {
      if (!logos || !Array.isArray(logos)) return [];

      const seen = new Set();
      return logos.filter((logoUrl) => {
        if (!logoUrl || typeof logoUrl !== 'string') return false; // Skip invalid entries
        
        // Normalize the URL for better comparison
        const normalizedUrl = logoUrl
          .trim()
          .toLowerCase()
          .replace(/\/+$/, '') // Remove trailing slashes
          .replace(/\?.*$/, ''); // Remove query parameters
        
        if (seen.has(normalizedUrl)) {
          console.log('Duplicate found and removed:', logoUrl);
          return false; // Skip duplicates
        }
        seen.add(normalizedUrl);
        return true; // Keep unique URLs
      });
    
  };
  useEffect(() => {
    const fetchAvatars = async () => {
      try {
        const response = await axios.get("/api/user/getEmployerAvatarImage");
        
        // console.log("🟢 API RESPONSE received:", response.data); (add to debug)
        
        
        // Filter out duplicate logos
        const uniqueAvatars = filterDuplicateLogos(response.data.avatars);
        
        setAvatars(uniqueAvatars);
        // setAvatars(response.data.avatars);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching avatars:", error);
      }
    };

    fetchAvatars();
  }, []);
  // Function to filter out duplicate logos
  // const filterDuplicateLogos = (logos) => {
  //   if (!logos || !Array.isArray(logos)) return [];

  //   const seen = new Set();
  //   return logos.filter((logoUrl) => {
  //     if (seen.has(logoUrl)) {
  //       return false; // Skip duplicates
  //     }
  //     seen.add(logoUrl);
  //     return true; // Keep unique URLs
  //   });
  // Function to filter out duplicate logos with better normalization
 

  return (
    <div className="home-companies-box1  py-5 px-0">
      <h2 className="title">Top Hiring Companies</h2>
      <div>
        {/* <LogoSlider data={logos} /> */}
        {/* <LogoSlider data={avatars} /> */}
        {isLoading ? (
          <div
            className="internships-jobs-section"
            style={{ background: "#F0FBFF", padding: "20px 0" }}
          ></div> // Show a loading indicator while avatars are being fetched
        ) : (
          <LogoSlider data={avatars} />
        )}
      </div>
    </div>
  );
}

export default Companies;
